import React, { Component } from 'react';
import { Combobox } from 'react-input-enhancements';
import { FormControl } from 'react-bootstrap';
import { connect } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';


//var countries = require('country-list')();


class CountrySelector extends Component {
  constructor(props){
    super(props);
    this.state = {
      value: ''
    }
    this.onChange = this.onChange.bind(this);
  }

  componentWillMount(){
    if(this.props.allCountres === this.props.countries){
      this.setState({ value: 'All Countries'})
    }
  }

   onChange(val){
     this.setState({ value: val.target.value});
    }

  onClick(){
    this.setState({ value: ""});
  }

  onSelect(val){
    if(val === undefined){
      alert("Please select a country from dropdown")
      return false;
    }
    if(val === 'All Countries'){
      this.props.addCountry(val);
      this.setState({ value: ""});
    } else if(this.props.countries.length > 10){
      this.props.addCountry(val);
      this.setState({ value: ""});
    } else if(this.props.countries.includes(val)){
      alert(`${val} is already selected`)
    //} else if(this.props.countries.length === 10){
    //  alert("You can only select up to 10 countries")
    } else {
      this.props.addCountry(val)
      this.setState({ value: ""});
    }
  }


    render(){

      const { allCountries, countries, countryToolTip, onCloseCountryToolTip = () => {} } = this.props;
      const { placeholder } = this.state;
      var countriesSelect = ['All Countries'];
      //var countries = allCountries.sort();
      var countriesSelect = countriesSelect.concat(allCountries);
      return (
        <div>
          {/* {
            countryToolTip?(
              <div>
                <div className="tool-tip-country">
                  <div className="tooltip-text">
                    <div style={{fontWeight: 'bold', display:'flex', justifyContent: 'space-between', alignSelf: 'center'}}>
                        <span>TIP</span>
                        <span style={{ cursor: 'pointer'}} onClick={onCloseCountryToolTip}>x</span>
                    </div>
                    <span>Use the dropdown menu to select individual countries (maximum of 10).</span>
                    </div>
                  </div>
                </div>):""
          } */}
          <Combobox
            options={countriesSelect}
            onChange={this.onChange}
            onSelect={this.onSelect.bind(this)}
            optionFilters={[]}
            autosize
            >
              {inputProps =>
                <FormControl
                  {...inputProps}
                  type='text'
                  id='country'
                  placeholder={countries.length === allCountries.length? 'All Countries':'Select Country'}
                  style={{width: "330px"}}
                  value={this.state.value}
                  onFocus={this.onClick.bind(this)}
                />
              }
            </Combobox>
            <FontAwesomeIcon icon="search" style={{color: "#c4c4c4"}}/>
        </div>
      );
  }
}

function mapStateToProps(state){
  return {
    countries: state.countries,
    allCountries: state.allCountries,
  }
};

function mapDispatchToProps(dispatch){
  return {
    addCountry: (country) => dispatch({ type: 'ADDCOUNTRY', value: country })

  }
}

export default connect(mapStateToProps, mapDispatchToProps)(CountrySelector);


/* {inputProps =>
  <FormControl
  {...inputProps}
  type='text'
  placeholder='No Country'
/>
} */



// WEBPACK FOOTER //
// ./src/components/CountrySelector.js